module.exports = {
    list: [
        'gray',
        'green',
        'yellow',
        'orange',
        'red',
    ],
};
